import SelectApiClientType from '@/api/SelectApiClientType'

export default {
    computed: {
        listFilters() {
            return [
                {
                    key: 'cloudcanteens.cutoffTime',
                    type: 'after',
                    inputType: 'checkbox',
                    label: 'labels.cloud_canteen_for_future',
                    value: this.$date().endOf('day').format(),
                },
                {
                    key: 'type',
                    label: 'labels.company_type',
                    type: 'exact',
                    inputType: 'select',
                    translate: true,
                    entity: SelectApiClientType.COMPANY_TYPE,
                    quick: true,
                },
            ]
        },
    },
}
